(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/single-rows/single-xpert.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/single-rows/single-xpert.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.SingleRowXpert = Backbone.Model.extend({
    defaults: {
      singleRows:
        svs.utils.ns.isNamespace(
          'svs.core.config.data.svsconfig.isSelfService'
        ) && svs.core.config.data.svsconfig.isSelfService === true
          ? [
            { size: 2 },
            { size: 3 },
            { size: 4 },
            { size: 5 },
            { size: 6 },
            { size: 7 },
            { size: 8 },
            { size: 9 },
            { size: 10 },
            { size: 11 },
            { size: 12 }
          ]
          : [
            { size: 1 },
            { size: 2 },
            { size: 3 },
            { size: 4 },
            { size: 5 },
            { size: 6 },
            { size: 7 },
            { size: 8 },
            { size: 9 },
            { size: 10 },
            { size: 11 },
            { size: 12 }
          ],
      hasBaseRow: false,
      useBoardRow: false,
      quickPick: svs.tipset.constants.NO_QP,
      fetchNew: false,
      generateSystem: false
    },

    initialize: function() {
      if (this.getCurrentSystem()) {
        this.setCurrentSystem(this.getCurrentSystem());
      }
      this.listenTo(
        svs.tipset.models.play,
        'change:isSingleRow',
        this.clearAll
      );
    },

    setData: function() {
      var systemsToShow = this.get('singleRows'),
        hasBaseRow = svs.tipset.collections.boardCollections.getHasMarksSetByUser();

      this.setIsValid(systemsToShow);

      this.set({
        systemsToShow: systemsToShow,
        useBoardRow: hasBaseRow,
        hasBaseRow: hasBaseRow,
        generateSystem: false
      });
    },

    getBombenSystems: function() {
      return this.toJSON().bombenSystem;
    },

    setCurrentSystem: function(system) {
      var fetchNew = !this.getCurrentSystem();
      this.set('fetchNew', fetchNew, { silent: true });
      this.setIsClicked(system);
      this.set('currentSystem', system, { silent: true });
    },

    url: function() {
      var useBaseRow = this.getUseBoardRow(),
        newUrl = '/wager/xpertwagers/',
        productApiName = svs.tipset.models.gameDefinitions.getAPIName(
          svs.tipset.collections.draws.getCurrentDraw().get('productId')
        ),
        baseRowStr = '',
        baseRowData = svs.tipset.collections.boardCollections.getBaseRow();
      if (useBaseRow && baseRowData) {
        baseRowStr =
          '&baseRow=' +
          svs.tipset.utils.convertBoardToItsData(
            svs.tipset.collections.boardCollections.getBaseRow()
          );
      }
      this.setQP();
      newUrl += productApiName + this.getXpertenSystemString() + baseRowStr;

      return svs.core.jupiter.url() + newUrl;
    },

    getXpertenSystemString: function() {
      return '?systemType=SROW&numRows=' + this.getCurrentSystem().size;
    },

    getCurrentSystem: function() {
      return this.get('currentSystem');
    },

    parse: function(response) {
      if (response.wager && response.wager.bets) {
        this.listenToOnce(
          svs.tipset.collections.boardCollections,
          'xpertBoardDataIsSet',
          this.setListeners
        );
        return response.wager.bets[0];
      }
    },

    setListeners: function() {
      if (!this.get('generateSystem')) {
        this.listenToOnce(
          svs.tipset.collections.boardCollections,
          'boardDataChanged',
          this.setQpModified
        );
      }
    },

    setQpModified: function() {
      this.clearAll();
      this.setQP({ isModified: true });
    },

    getXpertBoardData: function() {
      return this.get('game1X2Boards');
    },

    getSystem: function() {
      this.stopListening(
        svs.tipset.collections.boardCollections,
        'boardDataChanged',
        this.setQpModified
      );
      if (!this.get('generateSystem')) {
        this.fetch();
      } else {
        this.trigger('generateSystem');
      }
      this.trigger('toggleContextMenu');
    },

    generateSystem: function() {
      this.set(
        {
          generateSystem: false,
          fetchNew: true
        },
        { silent: true }
      );
      this.getSystem();
    },

    setUseBoardRow: function(useBoardRow) {
      this.set('useBoardRow', useBoardRow, { silent: true });
      this.set(
        'generateSystem',
        useBoardRow &&
          !svs.tipset.collections.boardCollections.getHasMarksSetByUser(),
        { silent: true }
      );
    },

    getUseBoardRow: function() {
      return this.get('useBoardRow');
    },

    clearAll: function() {
      this.stopListening(
        svs.tipset.collections.boardCollections,
        'boardDataChanged',
        this.setQpModified
      );
      this.setCurrentSystem(null);
      this.set('hasBaseRow', false, { silent: true });
      this.setUseBoardRow(false);
      this.set('generateSystem', false);
      this.set('quickPick', svs.tipset.constants.NO_QP);
      this.trigger('resetXperten');
      this.trigger('toggleContextMenu');
    },

    setIsClicked: function(currentSystem) {
      _.each(this.get('singleRows'), function(system) {
        if (
          currentSystem &&
          currentSystem.size &&
          system.size == currentSystem.size
        ) {
          system.isClicked = true;
        } else {
          system.isClicked = false;
        }
      });
    },

    setIsValid: function(inSystemsToValidate) {
      var systemsToValidate = inSystemsToValidate || this.get('systemsToShow'),
        nrOfStartedBoards = svs.tipset.collections.boardCollections.getActiveBoards()
          .length,
        self = this;

      _.each(systemsToValidate, function(system) {
        if (self.getUseBoardRow()) {
          if (system.size >= nrOfStartedBoards) {
            system.isValid = true;
          } else {
            system.isValid = false;
          }
        } else {
          system.isValid = true;
        }
      });
    },

    setQP: function(options) {
      var isModified =
          options && options.isModified ? options.isModified : false,
        useBaseRow = this.getUseBoardRow(),
        qp = useBaseRow
          ? svs.tipset.constants.QP_BASEROW
          : svs.tipset.constants.QP_NO_BASEROW;

      if (isModified) {
        qp = svs.tipset.constants.QP_MODIFIED;
      }

      this.set('quickPick', qp);
    },

    showActionbar: function() {
      var hasSystem = this.getCurrentSystem() != undefined,
        isNotModified =
          this.get('quickPick') != svs.tipset.constants.QP_MODIFIED,
        showActionBar = this.get('generateSystem');

      if (!this.get('generateSystem')) {
        showActionBar = hasSystem && isNotModified;
      }

      return showActionBar;
    },

    reloadXperten: function() {
      this.set('fetchNew', false, { silent: true });
      this.getSystem();
    }
  });
})(Backbone, _, svs);

 })(window);